import { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../../../img/iconImgAllClose.svg";
import styles from "../css//VoiceSettingScreen.module.css";
import { useTranslation } from "react-i18next";
import { EnglishPronunciation, VoiceGender } from "../util/voice";
import {
  getEnglishPronunciationFromLocalStorage,
  getSpeakingRateFromLocalStorage,
  getVoiceGenderFromLocalStroage,
  setEnglishPronunciationToLocalStorage,
  setSpeakingRateToLocalStorage,
  setVoiceGenderToLocalStroage,
} from "../../settings/util/voiceSettings";
import ContainerNavigationView from "../../common/view/ContainerNavigationView";
import ListCheckBoxButton from "../../common/view/ListCheckBoxButton";
import SpacingView from "../../common/view/SpaingView";
import { SpeakingRate } from "../model/SpeakingRate";
import { useBackToClose } from "../../../hooks/useBackToClose";

interface VoiceSettingScreenProps {
  open: boolean;
  handleOnUpdateValue?: () => void;
  handleOnClose?: () => void;
}

export default function VoiceSettingScreen(props: VoiceSettingScreenProps) {
  useBackToClose(props.open, () => props.handleOnClose?.());
  const { t } = useTranslation();

  const [checkedMale, setCheckedMale] = useState<boolean>(false);
  const [checkedFemale, setCheckedFemale] = useState<boolean>(false);

  const [checkedAmerica, setCheckedAmerica] = useState<boolean>(false);
  const [checkedEngland, setCheckedEngland] = useState<boolean>(false);
  const [checkedAustalia, setCheckedAustalia] = useState<boolean>(false);

  const [checkedSpeedSlow, setCheckedSpeedSlow] = useState<boolean>(false);
  const [checkedSpeedNormal, setCheckedSpeedNormal] = useState<boolean>(false);
  const [checkedSpeedFast, setCheckedSpeedFast] = useState<boolean>(false);

  useEffect(() => {
    updateGender();
    updatePronunciation();
    updateSpeakingRate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  function onClickBackground() {
    if (props.handleOnClose !== undefined) {
      props.handleOnClose();
    }
  }

  function onClickContentView(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
  }

  function setGender(gender: VoiceGender) {
    setVoiceGenderToLocalStroage(gender);
    updateGender();
  }

  function updateGender() {
    const genderValue = getVoiceGenderFromLocalStroage();
    setCheckedMale(genderValue === VoiceGender.male);
    setCheckedFemale(genderValue === VoiceGender.female);

    if (props.handleOnUpdateValue !== undefined) {
      props.handleOnUpdateValue();
    }
  }

  function setEnglishPronunciation(englishPronunciation: EnglishPronunciation) {
    setEnglishPronunciationToLocalStorage(englishPronunciation);
    updatePronunciation();

    if (props.handleOnUpdateValue !== undefined) {
      props.handleOnUpdateValue();
    }
  }

  function updatePronunciation() {
    const englishPronunciationValue = getEnglishPronunciationFromLocalStorage();
    setCheckedAmerica(
      englishPronunciationValue === EnglishPronunciation.america
    );
    setCheckedEngland(
      englishPronunciationValue === EnglishPronunciation.england
    );
    setCheckedAustalia(
      englishPronunciationValue === EnglishPronunciation.australia
    );
  }

  function setSpeakingRate(rate: SpeakingRate) {
    setSpeakingRateToLocalStorage(rate);
    updateSpeakingRate();

    if (props.handleOnUpdateValue !== undefined) {
      props.handleOnUpdateValue();
    }
  }

  function updateSpeakingRate() {
    const rate = getSpeakingRateFromLocalStorage();
    setCheckedSpeedSlow(rate === SpeakingRate.slow);
    setCheckedSpeedNormal(rate === SpeakingRate.normal);
    setCheckedSpeedFast(rate === SpeakingRate.fast);
  }

  if (props.open === true) {
    return (
      <>
        <div className={styles.stack}>
          <div className={styles.container} onClick={onClickBackground}>
            <div
              className={styles.contentContainer}
              onClick={onClickContentView}
            >
              <ContainerNavigationView
                open={true}
                title={t("voicesettings")}
                leftImageButtonImage={CloseIcon}
                onClickLeftImageButton={props.handleOnClose}
              />

              <div className={styles.settingItemContainer}>
                <span className={styles.settingTitle}>{t("voicegender")}</span>
                <div className={styles.settingContainer}>
                  <ListCheckBoxButton
                    id={1}
                    title={t("male")}
                    checked={checkedMale}
                    showingDivider={true}
                    onClick={() => {
                      setGender(VoiceGender.male);
                    }}
                  />
                  <ListCheckBoxButton
                    id={2}
                    title={t("female")}
                    checked={checkedFemale}
                    onClick={() => {
                      setGender(VoiceGender.female);
                    }}
                  />
                </div>

                <SpacingView height={24} />

                <span className={styles.settingTitle}>{t("voiceustouk")}</span>
                <div className={styles.settingContainer}>
                  <ListCheckBoxButton
                    id={1}
                    title={t("american")}
                    checked={checkedAmerica}
                    showingDivider={true}
                    onClick={() => {
                      setEnglishPronunciation(EnglishPronunciation.america);
                    }}
                  />
                  <ListCheckBoxButton
                    id={2}
                    title={t("english")}
                    checked={checkedEngland}
                    showingDivider={true}
                    onClick={() => {
                      setEnglishPronunciation(EnglishPronunciation.england);
                    }}
                  />
                  <ListCheckBoxButton
                    id={2}
                    title={t("australia")}
                    checked={checkedAustalia}
                    onClick={() => {
                      setEnglishPronunciation(EnglishPronunciation.australia);
                    }}
                  />
                </div>

                <SpacingView height={24} />

                <span className={styles.settingTitle}>
                  {t("VoiceSpekingRate")}
                </span>
                <div className={styles.settingContainer}>
                  <ListCheckBoxButton
                    id={1}
                    title={t("VoiceSpekingRateSlowlyValue")}
                    checked={checkedSpeedSlow}
                    showingDivider={true}
                    onClick={() => {
                      setSpeakingRate(SpeakingRate.slow);
                    }}
                  />
                  <ListCheckBoxButton
                    id={2}
                    title={t("VoiceSpekingRateNormalValue")}
                    checked={checkedSpeedNormal}
                    showingDivider={true}
                    onClick={() => {
                      setSpeakingRate(SpeakingRate.normal);
                    }}
                  />
                  <ListCheckBoxButton
                    id={2}
                    title={t("VoiceSpekingRateFasterValue")}
                    checked={checkedSpeedFast}
                    onClick={() => {
                      setSpeakingRate(SpeakingRate.fast);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}
